export default __webpack_public_path__ + "static/media/Group.5fbc18b1.svg";